import { DcaScenarioForm } from '../dca-scenario-form/dca-scenario-form';
export const NewDcaScenarioPage = () => {
  return <DcaScenarioForm />;
};
